import { graphql, useStaticQuery } from 'gatsby';

import { ContentfulErroresLibranzasNode } from '../adapters';
import { ERRORES_LIBRANZAS_ENTRY_ID } from '../config/contentfulIds';

interface ErroresLibranzasQueryResult {
    allContentfulTemplate: { nodes: ContentfulErroresLibranzasNode[] };
}

/**
 * `useStaticQuery` no admite variables, así que el `contentful_id` del filtro queda
 * quemado aquí y debe coincidir con `config/contentfulIds.ts`.
 */
const useErroresLibranzasQuery = (): ContentfulErroresLibranzasNode | undefined => {
    const data = useStaticQuery<ErroresLibranzasQueryResult>(graphql`
        query GET_ERRORES_LIBRANZAS {
            allContentfulTemplate(filter: { contentful_id: { eq: "nOwj87lMGQhbmfIEp3HRt" } }) {
                nodes {
                    contentful_id
                    tituloEnriquecido {
                        raw
                    }
                }
            }
        }
    `);

    return data?.allContentfulTemplate?.nodes?.find(
        (node) => node.contentful_id === ERRORES_LIBRANZAS_ENTRY_ID,
    );
};

export default useErroresLibranzasQuery;
